import React from "react";

import { Box, Button, Dialog, Typography } from "@mui/material";


import * as Api from 'api/api';
// import * as UsersApi from 'api/users';
import { ApiUser } from "api/users";


import * as F from 'tsui/Form';
import PageContents from "components/PageContents";
import session_ from "api/session";
import PageDialog from "../../../tsui/PageDialog";




interface UserDetailsTabProps {
    paymentId: string;
    onClose: () => void;

}





export default function RefundDialog(props: UserDetailsTabProps) {

    const form = F.useUpdateForm();

    const [resMsg, setResMsg] = React.useState<string | null>(null);
    

    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {

        Api.requestSession<any>('payments', 'refund', { paymentId: props.paymentId, language: session_.userLang! }).then(d => {
            if (d.answer) {

                setResMsg(d.answer)
            }
            // props.onClose();
            // console.log(`modified count is ${d.modifiedCount}`)
        }).catch(err => console.log(err));


    }, []);


    return <F.PageFormDialog title='User' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>

        <Box sx={{ width: '100%', textAlign: 'center', p: 3 }}>
            <Typography sx={{ fontSize: 'x-large' }}>Do you want to Refund this payment?</Typography>
        </Box>

        {resMsg !== null && (
           <PageDialog type='confirm' title='Answer' size='sm' onClose={props.onClose}>
                <Typography>{resMsg}</Typography>
            </PageDialog>
        )}

    </F.PageFormDialog>


}

